/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex } from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormList, TitleLabel } from 'src/components/Common/FormComponent';
import { generalExport } from 'src/pages/Policy/utils/fns';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import {
  ExchangeOnlinePolicyItem,
  // MailPolicyNameEnum,
} from '@Policy/utils/types';
import { fbApprovedSenderEmailEntriesSelector } from '@Policy/store/filters/fileBlocking';
import ImportModal from '../../Components/ImportModal';
// import { policyTypeNameSelector } from '@Policy/store/filters/general/store';

function FbApproveBlockList() {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state and action from store
  // const policyTypeName = contextSelector(policyTypeNameSelector);
  const fbApprovedSenderEmailEnabled = policySelector(
    (s) => s.tmFileblockings.fbApprovedSenderEmailEnabled
  );
  const approvedListMaxCount = contextSelector(
    (s) => s.config.approvedListMaxCount
  );
  const approvedSenderList = contextSelector(
    fbApprovedSenderEmailEntriesSelector,
    isEqual
  );
  const importFbApprovedSender = contextSelector(
    (s) => s.importFbApprovedSender
  );
  const setFbState = contextSelector((s) => s.setFbState);
  const addFbApprovedSender = contextSelector((s) => s.addFbApprovedSender);
  const removeFbApprovedSender = contextSelector(
    (s) => s.removeFbApprovedSender
  );
  // local state
  const [isImportModalVisible, setIsImportModalVisible] = React.useState(false);
  const handleOpenImportModal = React.useCallback(
    () => setIsImportModalVisible(true),
    []
  );
  const handleCloseImportModal = React.useCallback(
    () => setIsImportModalVisible(false),
    []
  );
  const handleExport = React.useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'approved-sender-list',
    });
  }, []);
  const handleImport = React.useCallback((entries: any) => {
    console.log('import entries', entries);
    importFbApprovedSender(entries as string[]);
    setIsImportModalVisible(false);
  }, []);
  const handleStatusChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFbState({
        fbApprovedSenderEmailEnabled: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  // const description = React.useMemo(() => {
  //   let desc = t('policy.approvedSenderList.desc');
  //   if (policyTypeName === MailPolicyNameEnum.ExchangeInlineOutbound) {
  //     desc = '';
  //   }
  //   return desc;
  // }, [policyTypeName]);

  return (
    <div>
      <Box ml="1px" mt="34px">
        <Flex direction="column">
          <TitleLabel title={t('policy.title.senders')} />
          <FormList
            onAdd={addFbApprovedSender}
            onDelete={removeFbApprovedSender}
            onExport={handleExport}
            onImport={handleOpenImportModal}
            list={approvedSenderList}
            limit={approvedListMaxCount}
            status={!!fbApprovedSenderEmailEnabled}
            setStatus={handleStatusChange}
            label={t('policy.approvedSenderList.title')}
            description={t('policy.approvedSenderList.supportWildcardDesc')}
          />
        </Flex>
      </Box>
      <ImportModal
        isVisible={isImportModalVisible}
        onClose={handleCloseImportModal}
        onImport={handleImport}
      />
    </div>
  );
}

export default React.memo(FbApproveBlockList);
